import { useEffect, useState } from "react";
import { countPending, onSyncChange, getQueueState } from "@/lib/syncEngine";

export function useOnlineStatus() {
    const [online, setOnline] = useState(typeof navigator !== "undefined" ? navigator.onLine : true);
    useEffect(() => {
        const up = () => setOnline(true);
        const down = () => setOnline(false);
        window.addEventListener("online", up);
        window.addEventListener("offline", down);
        return () => {
            window.removeEventListener("online", up);
            window.removeEventListener("offline", down);
        };
    }, []);
    return online;
}

export function useSyncState() {
    const [state, setState] = useState({ total: 0, pending: 0, syncing: 0, error: 0, done: 0, items: [] });
    useEffect(() => {
        let mounted = true;
        const refresh = async () => {
            const s = await getQueueState();
            if (mounted) setState(s);
        };
        const off = onSyncChange(refresh);
        refresh();
        // refresh periodically in case state changes outside of explicit notify()
        const interval = setInterval(refresh, 5_000);
        return () => { mounted = false; off(); clearInterval(interval); };
    }, []);
    return state;
}
